import { render, staticRenderFns } from "./event-detail.vue?vue&type=template&id=b6a9d114&scoped=true&"
import script from "./event-detail.vue?vue&type=script&lang=js&"
export * from "./event-detail.vue?vue&type=script&lang=js&"
import style0 from "./event-detail.vue?vue&type=style&index=0&id=b6a9d114&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a9d114",
  null
  
)

export default component.exports